"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_redux_1 = require("react-redux");
exports.default = (customerId) => ((0, react_redux_1.useSelector)((state) => state.data.customers.byId[customerId]));
//# sourceMappingURL=useCustomer.js.map